<template>
    <div class="container-fluid">
        <div class="row">
            <Menu />
            <div class="col-md-10 mt-4">
                <h1> <i class="fa-solid fa-buildings"></i> Cadastrar nova Recuperanda
                    <RouterLink style="float:right; position:relative; top:-10px;" to="/recuperanda" class="btn btn-primary"> <i class="fa-light fa-arrow-turn-down-left"></i> Voltar</RouterLink>
                </h1>
                <hr />
                 <div class="cont">
                    <Loading v-if="exibeLoading" />
                    <form v-if="!exibeLoading" @submit.prevent="handleRecuperanda">
                        <div class="form-group mb-3">
                            <input type="text" v-model="nome" placeholder="Nome da Classe" class="form-control" required/>
                        </div>
                        <div class="form-group mb-3">
                            <input type="text" v-model="cnpj" placeholder="CNPJ/MF" class="form-control" required/>
                        </div>
                        <button style="margin-left:0px;" class="btn btn-primary mt-4">Cadastrar</button>
                    </form>
                    <Alert style="margin-top:20px;" v-if="exibeAlert" :tipo="tipoS" :msg="msgS" />
            </div>
            </div>
        </div>
    </div>
    </template>

<script setup>
import { ref } from 'vue';
import Menu from '@/components/Menu.vue';
import Alert from '@/components/Alert.vue';
import Loading from '@/components/Loading.vue';
import recuperanda from '@/servicos/recuperanda';

const nome = ref('')
const cnpj = ref('')
const exibeAlert = ref(false)
const tipoS = ref('')
const msgS = ref('')
const exibeLoading = ref(false)

const handleRecuperanda = async () => {
    exibeLoading.value = true
    try {
        const response = await recuperanda.create(nome.value, cnpj.value)

        if(response.data.id){
        exibeAlert.value = true
        tipoS.value = 'success',
        msgS.value = "Recuperanda cadastrada com sucesso"
        nome.value = ''
        cnpj.value = ''
        exibeLoading.value = false
    }

} catch(error){
        if(error.response.data.message){
            exibeAlert.value = true
            tipoS.value = 'danger',
            msgS.value = error.response.data.message
            exibeLoading.value = false
        }
    }


    
   
    
}
</script>


    <style>
    
    h1 { color:rgba(0,0,0,.8); font-weight: 400; font-size:20px !important;}
    /* .table>:not(caption)>*>* { background-color:#1B3639;  } */
    th {color:rgba(255,255,255,.9) !important; padding:10px !important;}
    th { background-color: #1B3639 !important;}
    .cont { background:#fff; padding: 10px; border:1px solid rgba(0,0,0,.1); box-shadow:1px 2px 3px rgba(0,0,0,.4); }
    
    </style>